<template>
    <div class="filter-side b-r">
        <div class="filters-header b-r">
            <h4>Filters</h4>
            <!-- <div class="reset-filters"><i class="os-icon-close os-icon"></i><span>Reset Filters</span></div> -->
        </div>
        <form id="filterForm" @submit.prevent="applyFilters">
            <div class="filter-w first-child">
                <div class="filter-toggle" @click="filterToggle($event)">
                    <i class="fas fa-minus"></i>
                </div>
                <h6 class="filter-header no-filter" :class="isFilterApplied('identity')">Identity Filters</h6>
                <IdentityFilters :filters="filters" :selectedFilters="selectedFilters"/>
            </div>
            <!-- <div class="filter-w collapsed">
                <div class="filter-toggle" @click="filterToggle($event)">
                    <i class="fas fa-plus"></i>
                </div>
                <h6 class="filter-header no-filter" :class="isFilterApplied('movement')">Movement Filters</h6>
                <MovementFilters />
            </div>
            <div class="filter-w collapsed">
                <div class="filter-toggle" @click="filterToggle($event)">
                    <i class="fas fa-plus"></i>
                </div>
                <h6 class="filter-header no-filter" :class="isFilterApplied('workflow')">Workflow Filters</h6>
                <WorkflowFilters />
            </div>
            <div class="filter-w collapsed" @click="filterToggle($event)">
                <div class="filter-toggle">
                    <i class="fas fa-plus"></i>
                </div>
                <h6 class="filter-header no-filter" :class="isFilterApplied('retouch')">Retouch Filters</h6>
                <RetouchFilters />
            </div> -->
            <!-- <div class="filter-w collapsed" @click="filterToggle($event)">
            <div class="filter-toggle"><i class="fas fa-plus"></i></div>
            <h6 class="filter-header no-filter" :class="isFilterApplied('copy')">Copy Filters</h6>
            <CopyFilters />
        </div> -->
            <!-- <div class="filter-w collapsed" @click="filterToggle($event)">
                <div class="filter-toggle">
                    <i class="fas fa-plus"></i>
                </div>
                <h6 class="filter-header no-filter" :class="isFilterApplied('live_status')">Live Status Filters</h6>
                <LiveStatusFilters />
            </div> -->
            <div class="form-buttons-w">
                <button class="btn btn-primary" type="submit"> Apply</button>
                <button class="btn " type="reset" @click="resetFilters"> Reset</button>
            </div>
        </form>
    </div>
</template>

<script>
import IdentityFilters from '@/components/reportdesk/blocks/filters/IdentityFilters'
import MovementFilters from '@/components/reportdesk/blocks/filters/MovementFilters'
import WorkflowFilters from '@/components/reportdesk/blocks/filters/WorkflowFilters'
import RetouchFilters from '@/components/reportdesk/blocks/filters/RetouchFilters'
import LiveStatusFilters from '@/components/reportdesk/blocks/filters/LiveStatusFilters'
import CopyFilters from '@/components/reportdesk/blocks/filters/CopyFilters'

export default {
  props: ['filterFormData', 'appliedFilters', 'filters'],
  components: {
    IdentityFilters,
    MovementFilters,
    WorkflowFilters,
    RetouchFilters,
    LiveStatusFilters,
    CopyFilters
  },
  data () {
    return {
      selectedFilters: []
    }
  },
  methods: {
    applyFilters: function () {
      var form = document.getElementById('filterForm')
      var formData = new FormData(form)
      var searchFilters = []
      this.selectedFilters = []
      for (var p of formData) {
          let name = p[0];
          let value = p[1];
          
          if(value) {
            this.selectedFilters[name] = this.selectedFilters[name] || []
            this.selectedFilters[name].push(value)
          }
      }

      for (const name in this.selectedFilters) {
          var vals = this.selectedFilters[name]
          if (vals) {
            if(name == 'sku') {
              searchFilters.push([`item_identifier = ` + vals, `item_parent_identifier = ` + vals, `barcode = ` + vals])
            } else {
              var l = []
              vals.forEach(function(x) {
                l.push(`${name} = "${x}"`)
              })
              searchFilters.push(l)
            }
          }
      }
      this.$emit('filterInterface', searchFilters)
    },
    isFilterApplied: function (filter) {
      if (!this.appliedFilters) return false
      let obj = this.appliedFilters.find(o => o === filter)
      if (obj != null && obj != '' && obj != undefined) {
        return 'filtered'
      }
      return false
    },
    filterToggle: function (event) {
      if (
        !$(event.target).hasClass('fas') &&
        !$(event.target).hasClass('filter-toggle')
      ) { return false }
      var $filter_w = $(event.target).closest('.filter-w')
      if ($filter_w.hasClass('collapsed')) {
        $filter_w
          .find('.fa-plus')
          .removeClass('fa-plus')
          .addClass('fa-minus')
        $filter_w.find('.filter-body').slideDown(300, function () {
          $filter_w.removeClass('collapsed')
        })
      } else {
        $filter_w
          .find('.fa-minus')
          .removeClass('fa-minus')
          .addClass('fa-plus')
        $filter_w.find('.filter-body').slideUp(300, function () {
          $filter_w.addClass('collapsed')
        })
      }
      return false
    },
    resetFilters () {
      this.selectedFilters = []
      this.$emit('filterInterface', [])
    }
  },
  watch: {
    appliedFilters () {
      this.isFilterApplied()
    }
  }
}
</script>

<style scoped>
.first-child {
  margin-top: 52px;
}
.filters-header {
  position: absolute;
  top: 0;
  width: 331px;
  background: #f2f4f8;
  z-index: 999;
}
.filter-side .filtered:before {
  background-color: #75da62 !important;
}
.filter-side {
  overflow: auto;
}
.rentals-list-w .filter-side .filter-header .no-filter:before {
  background-color: #ddd !important;
}
.rentals-list-w .filter-side .filter-header .filter:before {
  background-color: #047bf8 !important;
}
.form-buttons-w {
  padding: 10px;
  float: right;
  position: absolute;
  bottom: 0;
}
</style>
